import { render, staticRenderFns } from "./Cog.vue?vue&type=template&id=6bb2ad98&scoped=true"
var script = {}
import style0 from "./Cog.vue?vue&type=style&index=0&id=6bb2ad98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2ad98",
  null
  
)

export default component.exports